








  import { Component, Vue } from 'vue-property-decorator';
  
@Component({
  name:"ListCours",
  components:{}
})
export default class ListCours extends Vue {
  private arianeItems = [
    { text: 'Administration', disabled: false, to: {name:'Admin'}, exact:true},
    { text: 'Dashboard', disabled: false, to: {name:'Dashboard'}, exact:true},
    { text: 'Cours',       disabled: true,  to: {name:'ListCours'}}
  ]  
}
